<template>
  <div class="fc">
    <div class="full-calendar-header fc-toolbar fc-header-toolbar">
      <div class="header-left">
        <h2>{{ title }}</h2>
      </div>
      <div class="header-center"></div>
      <div class="header-right">
        <div class="fc-button-group">
          <button type="button" @click.stop="goPrev" class="fc-prev-button fc-button fc-button-primary" aria-label="prev">
            <span class="fc-icon fc-icon-chevron-left"></span></button
          ><button @click.stop="goNext" type="button" class="fc-next-button fc-button fc-button-primary" aria-label="next">
            <span class="fc-icon fc-icon-chevron-right"></span>
          </button>
          <button @click.stop="exportExcel" type="button" class="fc-registration-button fc-button fc-button-primary">엑셀</button>
          <button @click.stop="goFormPage" type="button" class="fc-registration-button fc-button fc-button-primary">등록</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
import moment from "moment";
export default {
  created() {
    this.title = this.year + "/" + this.month;
  },
  props: {
    month: null,
    year: null,
    // currentMonth: {},
    titleFormat: {},
    firstDay: {},
    monthNames: {},
    locale: {},
  },
  data() {
    return {
      title: "",
    };
  },

  methods: {
    goFormPage() {
      this.$emit("goFormPage");
    },
    exportExcel() {
      this.$emit("exportExcel");
    },
    goPrev() {
      var newMonth = moment(this.currentMonth)
        .month(this.month - 1)
        .year(this.year)
        .subtract(1, "months")
        .startOf("month");
      this.currentMonth = newMonth;
      this.title = this.currentMonth.format("YYYY/MM");
      this.$emit("change", newMonth);
    },
    goNext() {
      var newMonth = moment(this.currentMonth)
        .month(this.month - 1)
        .year(this.year)
        .add(1, "months")
        .startOf("month");
      this.currentMonth = newMonth;
      this.title = this.currentMonth.format("YYYY/MM");
      this.$emit("change", newMonth);
    },
  },
};
</script>
<style lang="scss">
.full-calendar-header {
  display: flex;
  align-items: center;
  .header-left,
  .header-right {
    flex: 1;
  }
  .header-center {
    flex: 3;
    text-align: center;
    .title {
      margin: 0 10px;
    }
    .prev-month,
    .next-month {
      cursor: pointer;
    }
  }
}
</style>
